export default {
    path: '/fault',
    name: 'Fault',
    component: () => import(/* webpackChunkName: "fault" */ '../../views/fault/fault.vue')
}